import { render, staticRenderFns } from "./KraalSync.vue?vue&type=template&id=08a298de"
import script from "./KraalSync.vue?vue&type=script&lang=ts"
export * from "./KraalSync.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports